import "../Static Files/styles/Blog page/blog.css";
import image from "../Static Files/Images/Blog page/GettyImages-1773452656.jpg";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { getBlog } from "../slices/blogSlice";
import Loading from "../Components/Loading";
import ErrorPage from "../Components/ErrorPage";

const Blog = () => {
  const {selectedBlog,status,error} = useSelector((state)=>state.blogs)
  const {id} = useParams();
  const dispatch = useDispatch();


  useEffect(()=>{
    dispatch(getBlog(id));
  },[dispatch])


  if (status === "loading") {
    return <Loading />;
  }

  if (status === "failed") {
    return <ErrorPage />;
  }

  if (!selectedBlog) {
    return <ErrorPage />;
  }
  return (
    <>
      <main>
        <section style={{  background: `linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.8)), url(${selectedBlog.headerImageUrl})`}} className="blog-hero">
          <h1>{selectedBlog.title}</h1>
          <p>
            {selectedBlog.titleDesc}
          </p>
        </section>

        <section className="explore-section">
          <div className="texts-div">
            <h2>Explore</h2>
            <h1>Information about {selectedBlog.title}</h1>
            <p>
              {selectedBlog.description}
            </p>
          </div>

          <img src={selectedBlog.headerImageUrl} alt="washington" />
        </section>


        {/* <section className="gallery-section">
            <h3>Gallery</h3>
            <h1>Explore Wasikdin D.C</h1>
            <ul>
                <li>
                    <img src={image} alt="2" />
                </li>

                <li>
                    <img src={image} alt="2" />
                </li>

                <li>
                    <img src={image} alt="2" />
                </li>
            </ul>
        </section> */}
      </main>
    </>
  );
};

export default Blog;
